/**
 * Environment variables configuration for EKKO application
 */

interface Env {
  SOLANA_TRACKER_API_KEY: string;
  SOLANA_TRACKER_WS_URL: string;
  SUPABASE_URL: string;
  SUPABASE_ANON_KEY: string;
  SUPABASE_SERVICE_ROLE_KEY: string;
  SHYFT_API_KEY: string;
  [key: string]: string | undefined;
}

// Get environment variables
const getEnvVariables = (): Env => {
  // Vite exposes env variables under import.meta.env with VITE_ prefix
  // We need to remove the prefix and standardize the names
  const env: Env = {
    SOLANA_TRACKER_API_KEY: import.meta.env.VITE_SOLANA_TRACKER_API_KEY || '',
    SOLANA_TRACKER_WS_URL: import.meta.env.VITE_SOLANA_TRACKER_WS_URL || '',
    SUPABASE_URL: import.meta.env.VITE_SUPABASE_URL || '',
    SUPABASE_ANON_KEY: import.meta.env.VITE_SUPABASE_ANON_KEY || '',
    SUPABASE_SERVICE_ROLE_KEY: import.meta.env.VITE_SUPABASE_SERVICE_ROLE_KEY || '',
    SHYFT_API_KEY: import.meta.env.VITE_SHYFT_API_KEY || '',
  };
  
  return env;
};

export const env = getEnvVariables();

export default env; 